import { useRef, useState, useEffect } from "react";
import "../../src/assets/css/landingpage.css";
import carImage from "../assets/PevImages/HeroSectionCar.png";
import Section1Ciricle from "../assets/PevImages/Section1_Ciricle.png";
import ParkEaseimg1 from "../assets/PevImages/ParkEase_img1.png";
import section2img from "../assets/PevImages/733d788d-46b2-4f99-bc2f-8a5541380130 1.png";
import Images from "../assets/PevImages/Badge (2).png";
import Images1 from "../assets/PevImages/Badge (3).png";
import Section3 from "../assets/PevImages/Section3_frame1.png";
import Section3Loc from "../assets/PevImages/Section3_Location_Icon.png";
import ImagesFrame from "../assets/PevImages/Frame (13).png";
import SectionFrame from "../assets/PevImages/Section3_frame3.png";
import Section3Pay from "../assets/PevImages/Section3_Payment_Icon.png";
import FrameContent from "../assets/PevImages/Section3_Payment_Icon.png";
import SectionSecure from "../assets/PevImages/Secction3_Secure_Icon.png";
import SectionMobile from "../assets/PevImages/Secction3_Mobile_Icon.png";
import FrameAnalytics from "../assets/PevImages/Secction3_Analytics_Icon.png";
import ParkImg from "../assets/PevImages/ParkEase_img3.png";
import Logo1 from "../assets/PevImages/Section7_img1.png";
import Logo2 from "../assets/PevImages/Section7_img2.png";
import Logo3 from "../assets/PevImages/Section7_img3.png";
import Logo4 from "../assets/PevImages/Section7_img4.png";
import Logo5 from "../assets/PevImages/Section7_img5.png";
import Section8 from "../assets/PevImages/Section8_img.png";
import ScreenShot from "../assets/PevImages/Screenshot 2025-09-05 155243.png";
import "@fortawesome/fontawesome-free/css/all.min.css";
import { usePermissions } from "../context/PermissionContext";
import { Link, Navigate, replace, useNavigate } from "react-router-dom";
import LoadingComponent from "../components/ui/LoadingComponent";

const LandingPage = () => {
  const phoneImgRef = useRef(null);
  const featureStackRef = useRef(null);
  const [pricingPlans, setPricingPlans] = useState([]);
  const [loadingPlans, setLoadingPlans] = useState(true);
  const section4Ref = useRef(null);
  const section6Ref = useRef(null);
  const section8Ref = useRef(null);
  const carouselTrackRef = useRef(null);
  const [activeVariant, setActiveVariant] = useState(0);
  const navigate = useNavigate();
  useEffect(() => {
    const token = localStorage.getItem("access_token");
    const expiryTime = localStorage.getItem("token_expiry");
    const currentTime = Date.now();
    if (token && expiryTime && currentTime < parseInt(expiryTime, 10)) {
      navigate("/home", { replace: true });
    } else {
      localStorage.clear();
    }
  }, []);

  useEffect(() => {
    fetch(
      "https://pevbackend.codovio.com/public/api/v2/get-pricing-plans?product_id=1"
    )
      .then((response) => response.json())
      .then((result) => {
        if (result.success && result.data) {
          // .slice(0, 3) hata diya - ab saare plans aayenge
          setPricingPlans(result.data);
        }
        setLoadingPlans(false);
      })
      .catch((error) => {
        console.error("Error:", error);
        setLoadingPlans(false);
      });
  }, []);

  // IntersectionObserver for Feature Stack Animation
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && phoneImgRef.current) {
            phoneImgRef.current.classList.add("animate");
            observer.unobserve(featureStackRef.current);
          }
        });
      },
      { threshold: 0.5 }
    );

    if (featureStackRef.current) {
      observer.observe(featureStackRef.current);
    }

    return () => observer.disconnect();
  }, []);

  // IntersectionObserver for Section 2 Image Animation
  const imgRef = useRef(null);
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("animate");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.3 }
    );

    if (imgRef.current) {
      observer.observe(imgRef.current);
    }

    return () => observer.disconnect();
  }, []);

  // Scroll Animation for Section 4 Stats
  useEffect(() => {
    const handleScroll = () => {
      if (!section4Ref.current) return;
      const section4Position = section4Ref.current.getBoundingClientRect().top;
      const screenPosition = window.innerHeight / 1.3;

      if (section4Position < screenPosition) {
        const numbers = section4Ref.current.querySelectorAll(".stat-number");
        numbers.forEach((number) => {
          let start = 0;
          const end = parseInt(number.getAttribute("data-target"));
          const duration = 1000;
          const increment = end / (duration / 16);
          let current = start;

          function updateNumber() {
            if (current < end) {
              current += increment;
              number.textContent = Math.floor(current) + "+";
              requestAnimationFrame(updateNumber);
            } else {
              number.textContent = end + "+";
            }
          }
          updateNumber();
        });
        window.removeEventListener("scroll", handleScroll);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Scroll Animation for Section 6 Image
  useEffect(() => {
    const handleScroll = () => {
      if (!section6Ref.current) return;
      const section6Position = section6Ref.current.getBoundingClientRect().top;
      const screenPosition = window.innerHeight / 1.3;

      if (section6Position < screenPosition) {
        const image = section6Ref.current.querySelector(
          ".section_6_col_image img"
        );
        if (image) {
          image.style.animation = "slideFromTopLeft 2s ease forwards";
        }
        window.removeEventListener("scroll", handleScroll);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // IntersectionObserver for Section 8 Animation
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const mobileImg = document.getElementById("section_8_mobile_img");
            if (mobileImg) {
              mobileImg.classList.add("section_8_animate");
            }
          }
        });
      },
      { threshold: 0.3, rootMargin: "0px 0px -100px 0px" }
    );

    if (section8Ref.current) {
      observer.observe(section8Ref.current);
    }

    return () => observer.disconnect();
  }, []);

  // Carousel Pause/Resume
  useEffect(() => {
    const track = carouselTrackRef.current;
    if (!track) return;

    const handleMouseOver = () => {
      track.style.animationPlayState = "paused";
    };
    const handleMouseOut = () => {
      track.style.animationPlayState = "running";
    };

    track.addEventListener("mouseover", handleMouseOver);
    track.addEventListener("mouseout", handleMouseOut);

    return () => {
      track.removeEventListener("mouseover", handleMouseOver);
      track.removeEventListener("mouseout", handleMouseOut);
    };
  }, []);

  // Section 9 Variant Rotation
  useEffect(() => {
    const interval = setInterval(() => {
      setActiveVariant((prev) => (prev + 1) % 4);
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  // Footer Dropdown Toggle
  const handleDropdownToggle = (e) => {
    const toggle = e.currentTarget;
    const linksWrapper = toggle.nextElementSibling;
    const toggleIcon = toggle.querySelector(".toggle_icon");

    toggle.classList.toggle("active");
    linksWrapper.classList.toggle("active");

    toggleIcon.textContent = toggle.classList.contains("active") ? "−" : "+";
  };

  useEffect(() => {
    document.getElementById("global-style").disabled = true; // disable kar do
    return () => {
      document.getElementById("global-style").disabled = false; // wapas enable jab page chhodo
    };
  }, []);
  return (
    <>
      <div>
        {/* Navbar */}
        <nav className="navbar navbar-expand-lg fixed-top">
          <div className="container">
            <a className="navbar-brand" href="#">
              ParkEase
            </a>
            <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarNav"
              aria-controls="navbarNav"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon"></span>
            </button>
            <div
              className="collapse navbar-collapse justify-content-end"
              id="navbarNav"
            >
              <ul className="navbar-nav align-items-start">
                <li className="nav-item">
                  <a className="about nav-link" href="#about">
                    About Us
                  </a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="#pricing">
                    Our Pricing
                  </a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="#contact">
                    Contact Us
                  </a>
                </li>
                <li className="nav-item ms-3">
                  <Link to={"/sign-in"} className="btn-get-started">
                    GET STARTED
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </nav>

        {/* Hero Section */}
        <section className="hero-section">
          <div className="hero-bg-circle"></div>
          <div className="container-fluid hero-content-container">
            <div className="row h-100 align-items-center">
              <div className="col-lg-12 h-100 d-flex flex-column justify-content-between">
                <div className="hero-title-top ms-auto mt-auto">
                  <h6>
                    {" "}
                    End your parking worries with <br /> monthly parking
                    packages.
                    <br className="" />
                    Secure, convenient,{" "}
                    <span className="">
                      and <br /> affordable
                    </span>{" "}
                    parking solutions.
                  </h6>
                </div>
                <div className="hero-content"></div>
              </div>
            </div>
          </div>
          <div className="hero-bg-text-container">
            <div className="hero-main-text">
              PARKING <span className="highlight_experieince">EXPERIENCE</span>
            </div>
          </div>
          <div className="car-image">
            {/* <img
              src="./assets/PevImages/HeroSectionCar.png"
              alt="Car"
              className="car-img car-img-animated"
            /> */}
            <img
              src={carImage}
              alt="Car"
              className="car-img car-img-animated"
            />
          </div>
        </section>

        {/* Feature Stack Section */}
        <div className="container" ref={featureStackRef}>
          <div className="row feature-stack">
            <div className="col-md-6">
              <h3>
                A complete solution <br />
                ready to serve you
              </h3>
              <h5>Feature Stack</h5>
              <p>
                From booking your spot in advance to enjoying a seamless valet
                experience, our platform is built to make parking effortless,
                secure, and stress-free.
              </p>
              <div className="mt-4">
                <div className="card card-custom">
                  <h4>Book with Ease</h4>
                  <p>
                    Reserve your parking instantly through our mobile app or web
                    portal.
                  </p>
                </div>
                <div className="card card-custom">
                  <h4>Interactive Dashboard</h4>
                  <p>
                    Track your vehicle, manage bookings, & get real-time updates
                  </p>
                </div>
              </div>
              <button className="btn btn-custom">Learn More</button>
            </div>
            <div className="col-md-6 position-relative image-stack">
              {/* <img
                src="Images/Section1_Ciricle.png"
                alt=""
                className="circle-bg-img"
              /> */}
              <img src={Section1Ciricle} alt="" className="circle-bg-img" />
              {/* <img
                src="Images/ParkEase_img1.png"
                alt=""
                className="phone-img animate-on-scroll"
                ref={phoneImgRef}
              /> */}
              <img
                src={ParkEaseimg1}
                alt=""
                className="car-img car-img-animated"
              />
            </div>
          </div>
        </div>

        {/* App Availability Section */}
        <div className="container-fluid section_2_full">
          <div className="row app_availability">
            <div className="col-md-6">
              <div className="section_2_img-container">
                <img
                  src={section2img}
                  //   src="Images/733d788d-46b2-4f99-bc2f-8a5541380130 1.png"
                  alt="App Availability"
                  className="section_2_img img-fluid"
                  style={{
                    maxWidth: "100%",
                    height: "auto",
                    width: "100%",
                    maxHeight: "70vh",
                    objectFit: "contain",
                  }}
                  ref={imgRef}
                />
              </div>
            </div>
            <div className="col-md-6 section2_text_content">
              <h2>
                App Is Available
                <br />
                For Free In
              </h2>
              <h3>App | Play Store</h3>
              <p>
                Finding a safe parking spot has never been easier. With our
                valet parking app, you can book in advance, track your Vehicle
                in real time, and enjoy smooth cashless payments. Whether you
                are going to work, attending an event, or just stopping by the
                city, our verified valets ensure your vehicle is secure and
                ready when you need it. Simple, fast, and reliable — parking
                made effortless.
              </p>
              <div>
                {/* <img src="Images/Badge (2).png" alt="" /> */}
                {/* <img src="Images/Badge (3).png" alt="" /> */}
                <img src={Images} alt="" />
                <img src={Images1} alt="" />
              </div>
            </div>
          </div>
        </div>

        {/* Smart Parking Section */}
        <div className="section_3_full">
          <div className="section3_cstm">
            <h1 className="text-dark mt-5">
              Everything You Need for{" "}
              <span className="smar_paking_text">Smart Parking</span>
            </h1>
            <p className="p-3">
              Our comprehensive parking solution combines cutting-edge
              technology with user-friendly design to revolutionize your parking
              experience.
            </p>
          </div>
          <div className="section3_frames_container">
            <div className="section3_frame">
              <img
                src={Section3}
                // src="Images/Section3_frame1.png"
                alt="An image showing a well-lit but empty underground parking lot."
              />
              <div className="frame_content">
                <img
                  src={Section3Loc}
                  //   src="Images/Section3_Location_Icon.png"

                  alt="A red location pin icon"
                  className="frame_icon"
                />
                <h3>Smart Location Finder</h3>
                <p>
                  AI-powered search finds the closest available parking spots
                  based on your destination and preferences.
                </p>
              </div>
            </div>
            <div className="section3_frame">
              <img
                // src="Images/Frame (13).png"
                src={ImagesFrame}
                alt="An image showing a hand holding a blue credit card tapping a mobile payment terminal."
              />
              <div className="frame_content">
                <img
                  //   src="Images/Section3_Payment_Icon.png"
                  src={Section3Pay}
                  alt="A red contactless payment icon"
                  className="frame_icon"
                />
                <h3>Contactless Payments</h3>
                <p>
                  Secure, fast payments through the app. No more fumbling for
                  coins or cards at parking meters.
                </p>
              </div>
            </div>
            <div className="section3_frame">
              <img
                // src="Images/Section3_frame3.png"
                src={SectionFrame}
                alt="An image showing a hand holding a blue credit card tapping a mobile payment terminal."
              />
              <div className="frame_content">
                <img
                  //   src="Images/Section3_Payment_Icon.png"
                  src={FrameContent}
                  alt="A red contactless payment icon"
                  className="frame_icon"
                />
                <h3>Contactless Payments</h3>
                <p>
                  Secure, fast payments through the app. No more fumbling for
                  coins or cards at parking meters.
                </p>
              </div>
            </div>
            <div className="section3_frame text_only">
              <div className="frame_content">
                <img
                  //   src="Images/Secction3_Secure_Icon.png"
                  src={SectionSecure}
                  alt="A red shield icon"
                  className="frame_icon"
                />
                <h3>Secure Reservations</h3>
                <p>
                  Book your spot in advance with guaranteed availability and
                  secure payment processing.
                </p>
              </div>
            </div>
            <div className="section3_frame text_only">
              <div className="frame_content">
                <img
                  //   src="Images/Secction3_Mobile_Icon.png"
                  src={SectionMobile}
                  alt="A red mobile icon"
                  className="frame_icon"
                />
                <h3>Mobile-First Design</h3>
                <p>
                  Intuitive mobile app designed for ease of use while you're on
                  the go.
                </p>
              </div>
            </div>
            <div className="section3_frame text_only">
              <div className="frame_content">
                <img
                  //   src="Images/Secction3_Analytics_Icon.png"
                  src={FrameAnalytics}
                  alt="A red analytics icon"
                  className="frame_icon"
                />
                <h3>Usage Analytics</h3>
                <p>
                  Track your parking history, expenses, and discover your most
                  visited locations.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Stats Section */}
        <div className="section_4_full" ref={section4Ref}>
          <div className="stats-container">
            <div className="stat-box">
              <h2 className="stat-number" data-target="265">
                0+
              </h2>
              <p className="stat-label">Active Installation</p>
            </div>
            <div className="stat-box">
              <h2 className="stat-number" data-target="155">
                0+
              </h2>
              <p className="stat-label">Download</p>
            </div>
            <div className="stat-box">
              <h2 className="stat-number" data-target="95">
                0+
              </h2>
              <p className="stat-label">Award Winnings</p>
            </div>
            <div className="stat-box">
              <h2 className="stat-number" data-target="305">
                0+
              </h2>
              <p className="stat-label">Total Subscriber</p>
            </div>
          </div>
        </div>

        <div className="section_5_full" id="pricing">
          <div className="section_5_recommended">Recommended</div>

          <div className="section_5_container">
            {loadingPlans ? (
              <div style={{ textAlign: "center", padding: "50px" }}>
                <LoadingComponent />
              </div>
            ) : pricingPlans.length > 0 ? (
              pricingPlans.map((plan, index) => (
                <div
                  key={plan.plan_id}
                  className={`section_5_plan ${
                    index === 0
                      ? "section_5_basic"
                      : index === 1
                      ? "section_5_premium"
                      : "section_5_business"
                  }`}
                >
                  <div className="section_5_plan_header">
                    <h3 className="section_5_plan_title">{plan.plan_name}</h3>
                    <p className="section_5_plan_subtitle">
                      {plan.description}
                    </p>
                    <div className="section_5_plan_price">
                      ${plan.base_price}
                      <span className="section_5_plan_period"> per month</span>
                    </div>
                  </div>

                  <ul className="section_5_plan_features">
                    <li>{plan.plan_type} plan type</li>
                    <li>{plan.customer_segment} businesses</li>
                    <li>Up to {plan.max_vehicles_allowed} vehicles</li>
                    {plan.per_vehicle_fee !== "0.00" && (
                      <li>${plan.per_vehicle_fee} per vehicle fee</li>
                    )}
                    {plan.is_trial_plan && <li>Trial plan included</li>}
                  </ul>

                  <button
                    className={`section_5_plan_button ${
                      index === 1 ? "section_5_plan_button_premium" : ""
                    }`}
                    onClick={() =>
                      navigate("/sign-up", {
                        state: { plan },
                      })
                    }
                  >
                    {index === 1 ? "Get Premium Now" : "Choose Plan"}
                  </button>
                </div>
              ))
            ) : (
              <p style={{ textAlign: "center", padding: "50px" }}>
                No pricing plans available
              </p>
            )}
          </div>

          <div className="section_5_footer">
            <p className="section_5_footer_text">
              Have custom requirements? We can create a special package for you
            </p>
            <button className="section_5_footer_button">
              Contact for Custom Plan
            </button>
          </div>
        </div>

        {/* Parking Journey Section */}
        <div className="section_6_full container" ref={section6Ref}>
          <div className="section_6_container">
            <div className="section_6_row">
              <div className="section_6_col section_6_col_image">
                {/* <img src="Images/ParkEase_img3.png" alt="" /> */}
                <img src={ParkImg} alt="" />
              </div>
              <div className="section_6_col section_6_col_text">
                <h2 className="section_6_title">
                  Your Parking Journey, <br /> Perfectly Tracked
                </h2>
                <p className="section_6_subtext">
                  Get a complete overview of your valet history, saved vehicles,
                  and payment records — all in one convenient dashboard. Update
                  your profile anytime, manage your preferences, and make every
                  parking experience faster and more personalized.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Carousel Section */}
        <div className="section_7_full">
          <div className="carousel_container">
            <div className="carousel_track" ref={carouselTrackRef}>
              {/* <img src="Images/Section7_img1.png" alt="Company Logo 1" />
               */}
              <img src={Logo1} alt="Company Logo 1" />

              <img src={Logo2} alt="Company Logo 2" />
              <img src={Logo3} alt="Company Logo 3" />
              <img src={Logo4} alt="Company Logo 4" />
              <img src={Logo5} alt="Company Logo 5" />
              <img src={Logo1} alt="Company Logo 1" />
              <img src={Logo2} alt="Company Logo 2" />
              <img src={Logo3} alt="Company Logo 3" />
              <img src={Logo4} alt="Company Logo 4" />
              <img src={Logo5} alt="Company Logo 5" />
            </div>
          </div>
        </div>

        {/* About Section */}
        <div className="section_8_full" id="about" ref={section8Ref}>
          <div className="section_8_container">
            <div className="section_8_header">
              <h2>About Our App</h2>
              <p>
                Discover how our valet parking app makes <br /> parking smarter,
                faster, and stress-free.
              </p>
            </div>
            <div className="section_8_content">
              <div className="section_8_image_col">
                <img
                  src={Section8}
                  //   src="Images/Section8_img.png"

                  alt="Mobile App Screenshot"
                  id="section_8_mobile_img"
                />
              </div>
              <div className="section_8_text_col">
                <h3>
                  Smart Design,{" "}
                  <span className="seamless_highlight">Seamless Parking</span>
                </h3>
                <p>
                  Our app is built to transform the way you park. From real-time
                  spot availability to cashless payments and secure
                  reservations, everything is designed to give you a hassle-free
                  experience at every step.
                </p>
                <p>
                  Whether you’re on the go, booking ahead, or managing multiple
                  vehicles, our mobile-first design ensures that parking is
                  always just a tap away. Fast, reliable, and easy to use —
                  that’s the future of valet parking.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Variants Section */}
        <div className="section_9_full container">
          <div className="section_9_wrapper">
            <div
              className={`section_9_variant ${
                activeVariant === 0 ? "active" : ""
              }`}
            >
              <div className="row justify-content-center">
                <div className="col-md-4 mt-5">
                  <div className="btn btn-warning rounded-pill text-white section_9_btn_cstm">
                    Rapid Service Response
                  </div>
                  <div className="mt-3">
                    <h2>24/7 Quick Resolution</h2>
                    <p className="mt-4">
                      Our technically skilled customer service team can
                      effectively coordinate with your tech department and
                      independently resolve 80-85% of issues.
                    </p>
                  </div>
                </div>
                <div
                  className="col-md-8 section_9_img_cstm"
                  style={{ backgroundColor: "orange" }}
                >
                  <img
                    // src="Images/Screenshot 2025-09-05 155243.png"
                    src={ScreenShot}
                    alt="Customer Support Interface"
                  />
                </div>
              </div>
            </div>
            <div
              className={`section_9_variant ${
                activeVariant === 1 ? "active" : ""
              }`}
            >
              <div className="row justify-content-center">
                <div className="col-md-4 mt-5">
                  <div
                    className="btn rounded-pill text-white section_9_btn_cstm"
                    style={{ backgroundColor: "#5fcf80" }}
                  >
                    Proactive Alerts
                  </div>
                  <div className="mt-3">
                    <h2>Detect Issues Before Users</h2>
                    <p className="mt-4">
                      Get real-time notifications for anomalies and stop attacks
                      before damage happens.
                    </p>
                  </div>
                </div>
                <div
                  className="col-md-8 section_9_img_cstm"
                  style={{ backgroundColor: "#5fcf80" }}
                >
                  <img
                    // src="Images/Screenshot 2025-09-05 155243.png"
                    src={ScreenShot}
                    alt="Customer Support Interface"
                  />
                </div>
              </div>
            </div>
            <div
              className={`section_9_variant ${
                activeVariant === 2 ? "active" : ""
              }`}
            >
              <div className="row justify-content-center">
                <div className="col-md-4 mt-5">
                  <div
                    className="btn rounded-pill text-white section_9_btn_cstm"
                    style={{ backgroundColor: "#4dabf7" }}
                  >
                    Real-Time Monitoring
                  </div>
                  <div className="mt-3">
                    <h2>Monitor & Analyze</h2>
                    <p className="mt-4">
                      Live dashboards give you deep insights into system health
                      and traffic behavior.
                    </p>
                  </div>
                </div>
                <div
                  className="col-md-8 section_9_img_cstm"
                  style={{ backgroundColor: "#4dabf7" }}
                >
                  <img src={ScreenShot} alt="Customer Support Interface" />
                </div>
              </div>
            </div>
            <div
              className={`section_9_variant ${
                activeVariant === 3 ? "active" : ""
              }`}
            >
              <div className="row justify-content-center">
                <div className="col-md-4 mt-5">
                  <div
                    className="btn rounded-pill text-white section_9_btn_cstm"
                    style={{ backgroundColor: "#ff6f61" }}
                  >
                    Advanced Reports
                  </div>
                  <div className="mt-3">
                    <h2>Data-Driven Insights</h2>
                    <p className="mt-4">
                      Get weekly reports to track performance, failures, and
                      critical metrics with ease.
                    </p>
                  </div>
                </div>
                <div
                  className="col-md-8 section_9_img_cstm"
                  style={{ backgroundColor: "#ff6f61" }}
                >
                  <img src={ScreenShot} alt="Customer Support Interface" />
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Footer */}
        <footer className="footer_main">
          <div className="footer_container">
            <div className="footer_content">
              <div className="footer_brand">
                <div className="footer_logo">
                  <div className="footer_logo_icon">P</div>
                  <span className="footer_logo_text">PARKEASE</span>
                </div>
                <p className="footer_description">
                  Parking system with premium service
                </p>
                <div className="footer_social">
                  <a href="#" className="footer_social_icon">
                    <i className="fab fa-google"></i>
                  </a>
                  <a href="#" className="footer_social_icon">
                    <i className="fab fa-twitter"></i>
                  </a>
                  <a href="#" className="footer_social_icon">
                    <i className="fab fa-instagram"></i>
                  </a>
                  <a href="#" className="footer_social_icon">
                    <i className="fab fa-linkedin"></i>
                  </a>
                </div>
              </div>
              <div className="footer_dropdown_column">
                <div
                  className="footer_column_toggle"
                  onClick={handleDropdownToggle}
                >
                  <h4 className="footer_column_title">Plan</h4>
                  <span className="toggle_icon">+</span>
                </div>
                <div className="footer_links_wrapper">
                  <a href="#" className="footer_link">
                    Regular
                  </a>
                  <a href="#" className="footer_link">
                    Premium
                  </a>
                  <a href="#" className="footer_link">
                    Golden
                  </a>
                  <a href="#" className="footer_link">
                    Luxury
                  </a>
                </div>
              </div>
              <div className="footer_dropdown_column">
                <div
                  className="footer_column_toggle"
                  onClick={handleDropdownToggle}
                >
                  <h4 className="footer_column_title">Services</h4>
                  <span className="toggle_icon">+</span>
                </div>
                <div className="footer_links_wrapper">
                  <a href="#" className="footer_link">
                    Spacious Parking
                  </a>
                  <a href="#" className="footer_link">
                    CCTV
                  </a>
                  <a href="#" className="footer_link">
                    Safety
                  </a>
                  <a href="#" className="footer_link">
                    Cleaning Services
                  </a>
                </div>
              </div>
              <div className="footer_dropdown_column">
                <div
                  className="footer_column_toggle"
                  onClick={handleDropdownToggle}
                >
                  <h4 className="footer_column_title">Company</h4>
                  <span className="toggle_icon">+</span>
                </div>
                <div className="footer_links_wrapper">
                  <a href="#" className="footer_link">
                    About
                  </a>
                  <a href="#" className="footer_link">
                    Terms
                  </a>
                  <a href="#" className="footer_link">
                    Privacy Policy
                  </a>
                </div>
              </div>
              <div className="footer_dropdown_column">
                <div
                  className="footer_column_toggle"
                  onClick={handleDropdownToggle}
                >
                  <h4 className="footer_column_title">More</h4>
                  <span className="toggle_icon">+</span>
                </div>
                <div className="footer_links_wrapper">
                  <a href="#" className="footer_link">
                    Documentation
                  </a>
                  <a href="#" className="footer_link">
                    License
                  </a>
                </div>
              </div>
            </div>
            <div className="footer_copyright">
              <p>&copy; 2025 ParkEase. All rights reserved.</p>
            </div>
          </div>
        </footer>
      </div>
    </>
  );
};
export default LandingPage;
